module.exports = __webpack_public_path__ + "img/2-4.fa5df87f.png";